import { states } from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";
import { yesNo, yesNoUnsure } from "../../../../constants/options";
import { textToBoolean } from "../../../../utilities/dataUtilities";

function InjuryEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createEditScreenInput,
    createCustomLabelSelect,
    createCustomLabelTextArea
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Injury Information</div>

      <div className={Styles.row}>
        {createToggleInput(fields.wasAnyoneInjured, "100%", yesNoUnsure, true)}
      </div>
      <div className={Styles.column}>
        {textToBoolean(fields.wasAnyoneInjured.value) && (
          <>
            <div className={Styles.row}>
              {createEditScreenInput(fields.injuredFirstName, "50%", Styles.input, Styles.label)}
              {createEditScreenInput(fields.injuredLastName, "50%", Styles.input, Styles.label)}
              </div>
            <div className={Styles.row}>
              {createEditScreenInput(fields.injuredAddress, "50%", Styles.input, Styles.label)}
              {createEditScreenInput(fields.injuredCity, "50%", Styles.input, Styles.label)}
            </div>
             <div className={Styles.row}>
              {createCustomLabelSelect(fields.injuredState, states, Styles.select, Styles.label, {placeholder: "Select a State"})}
              {createEditScreenInput(fields.injuredCounty, "50%", Styles.input, Styles.label)}
            </div> 
            <div className={Styles.row}>
              {createEditScreenInput(fields.injuredZipcode, "50%", Styles.input, Styles.label)}
            </div>

            <div className={Styles.column} style={{ alignItems: "flex-start" }}>
              {createCustomLabelTextArea(fields.injuryDescription, "100%", Styles.textarea, Styles.blockLabel)}
            </div>
            <div className={Styles.row}></div>
            {createToggleInput(fields.wasTreatmentProvided, "100%", yesNo, true)}
            {fields.wasTreatmentProvided.value && (
              <>
                <div className={Styles.title}>Provider Information</div>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.medicalProviderFirstName, "50%", Styles.input, Styles.label, {altLabel: "First Name"})}
                  {createEditScreenInput(fields.medicalProviderLastName, "50%", Styles.input, Styles.label, {altLabel: "Last Name"})}
                </div>
                <div className={Styles.row}>
                  {createEditScreenInput(fields.medicalProviderAddress, "50%", Styles.input, Styles.label)}
                  {createEditScreenInput(fields.medicalProviderCity, "50%", Styles.input, Styles.label)}
                </div>
                <div className={Styles.row}>
                  {createCustomLabelSelect(fields.medicalProviderState, states, Styles.select, Styles.label, {placeholder: "Select a state"})}
                  {createEditScreenInput(fields.medicalProviderZipcode, "50%", Styles.input, Styles.label)}
                </div>
              </>
            )}
          </>
        )}
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default InjuryEdit;
